<script>

export default {
	name: 'LangSwitch',
	
	components: {
	
	},
	
	data() {
		return {
			actLang:''
		}
	},
	
	props: {'propActLang': String, 'langsData': Array},
	emits: ["propActLang", "changeLang"],
	
	mounted:function(){
		if(localStorage.Lang!=null) {this.actLang=localStorage.Lang} else { this.actLang='sk'}
	},
	
	methods: {
		
		setLang:function(langId){
			localStorage.Lang=langId;
			this.actLang=langId;
			this.$emit('changeLang', langId)
			//console.log(localStorage.Lang)
		},
	
	},	
	
	watch: {
		
	},

	computed:{
		
	},
	
}

</script>

<template>
	<div class="row">
		<div class="col-12">
			<span v-for='(i) in langsData' :key="i" ><span :class='{active:actLang==i.shorts}' v-on:click='setLang(i.shorts)'>{{i.shorts}}&nbsp;</span> </span>
		</div>
	</div>
</template>


